import {parseISO, differenceInCalendarYears} from "date-fns";
import GeoService from "../services/geo";

/*
 * A full version of a Guest object
 */
export default class Guest {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.name = apiResponse.name;
        this.surname = apiResponse.surname;
        this.sex = apiResponse.sex;
        this.nationality = GeoService.COUNTRIES.find(c => c.code === apiResponse.nationality);
        this.countryOfResidence = GeoService.COUNTRIES.find(c => c.code === apiResponse.countryOfResidence);
        this.placeOfResidence = GeoService.CITIES.find(c => c.code === apiResponse.placeOfResidence);
        this.dateOfBirth = parseISO(apiResponse.dateOfBirth);
        this.countryOfBirth = GeoService.COUNTRIES.find(c => c.code === apiResponse.countryOfBirth);
        this.placeOfBirth = GeoService.CITIES.find(c => c.code === apiResponse.placeOfBirth);
        this.documentType = apiResponse.documentType;
        this.documentNumber = apiResponse.documentNumber;
        this.countryOfIssue = GeoService.COUNTRIES.find(c => c.code === apiResponse.countryOfIssue);
        this.createdAt = parseISO(apiResponse.createdAt);
        this.localTouristTaxExclusionCode = apiResponse.localTouristTaxExclusionCode
        this.guestStays = apiResponse.guestStays ? apiResponse.guestStays.map(gs => new GuestStay(this, gs)) : [];
    }

    clone() {
        const guest = new Guest({});
        guest.id = this.id;
        guest.name = this.name;
        guest.surname = this.surname;
        guest.sex = this.sex;
        guest.nationality = this.nationality;
        guest.countryOfResidence = this.countryOfResidence;
        guest.placeOfResidence = this.placeOfResidence;
        guest.dateOfBirth = this.dateOfBirth;
        guest.countryOfBirth = this.countryOfBirth;
        guest.placeOfBirth = this.placeOfBirth;
        guest.documentType = this.documentType;
        guest.documentNumber = this.documentNumber;
        guest.countryOfIssue = this.countryOfIssue;
        guest.createdAt = this.createdAt;
        guest.localTouristTaxExclusionCode = this.localTouristTaxExclusionCode;
        guest.guestStays = this.guestStays.map(gs => gs.clone(this));
        return guest;
    }

    getFullName() {
        return `${this.surname} ${this.name}`;
    }

    getAge() {
        return differenceInCalendarYears(new Date(), this.dateOfBirth);
    }

    hasIdDocument = () => {
        return !!this.documentType && !!this.documentNumber && !!this.countryOfIssue;
    }

    isCheckedIn = () => {
        return !!this.arrival;
    }

    hasLocalTouristTaxExclusion = () => {
        return !!this.localTouristTaxExclusionCode;
    }

    canEdit = () => {
        return this.guestStays.length === 0
    }
}


export class GuestStay {
    constructor(guestDocument, apiResponse) {
        this.id = apiResponse.id;
        this.arrival = parseISO(apiResponse.arrival);
        this.departure = apiResponse.departure ? parseISO(apiResponse.departure) : null;
        this.expectedDeparture = parseISO(apiResponse.expectedDeparture);
        this.abitStay = apiResponse.abitStay ? new AbitStay(apiResponse.abitStay) : null;
        this.alloggiatiStay = apiResponse.alloggiatiStay ? new AlloggiatiStay(apiResponse.alloggiatiStay) : null;
        this.guestDocument = guestDocument;
    }

    clone(guestDocument) {
        const guestStay = new GuestStay(guestDocument, {});
        guestStay.id = this.id;
        guestStay.arrival = this.arrival;
        guestStay.departure = this.departure;
        guestStay.expectedDeparture = this.expectedDeparture;
        guestStay.abitStay = this.abitStay ? this.abitStay.clone() : null;
        guestStay.alloggiatiStay = this.alloggiatiStay ? this.alloggiatiStay.clone() : null;
        return guestStay;
    }
}


export class AbitStay {
    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.abitArrival = apiResponse.abitArrival ? parseISO(apiResponse.abitArrival) : null;
        this.abitDeparture = apiResponse.abitDeparture ? parseISO(apiResponse.abitDeparture) : null;
        this.abitArrivalUploadedAt = apiResponse.abitArrivalUploadedAt ? parseISO(apiResponse.abitArrivalUploadedAt) : null;
        this.abitArrivalError = apiResponse.abitArrivalError;
        this.abitDepartureUploadedAt = apiResponse.abitDepartureUploadedAt ? parseISO(apiResponse.abitDepartureUploadedAt) : null;
        this.abitDepartureError = apiResponse.abitDepartureError;
    }

    clone() {
        const abitStay = new AbitStay({});
        abitStay.id = this.id;
        abitStay.abitArrival = this.abitArrival;
        abitStay.abitDeparture = this.abitDeparture;
        abitStay.abitArrivalUploadedAt = this.abitArrivalUploadedAt;
        abitStay.abitArrivalError = this.abitArrivalError;
        abitStay.abitDepartureUploadedAt = this.abitDepartureUploadedAt;
        abitStay.abitDepartureError = this.abitDepartureError;
        return abitStay;
    }
}


export class AlloggiatiStay {
    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.alloggiatiArrival = apiResponse.alloggiatiArrival ? parseISO(apiResponse.alloggiatiArrival) : null;
        this.alloggiatiDeparture = apiResponse.alloggiatiDeparture ? parseISO(apiResponse.alloggiatiDeparture) : null;
        this.alloggiatiUploadedAt = apiResponse.alloggiatiUploadedAt ? parseISO(apiResponse.alloggiatiUploadedAt) : null;
    }

    clone() {
        const alloggiatiStay = new AlloggiatiStay({});
        alloggiatiStay.id = this.id;
        alloggiatiStay.alloggiatiArrival = this.alloggiatiArrival;
        alloggiatiStay.alloggiatiDeparture = this.alloggiatiDeparture;
        alloggiatiStay.alloggiatiUploadedAt = this.alloggiatiUploadedAt;
        return alloggiatiStay;
    }
}